<template>
    <div class="p-4">
        <div class="border-bottom mb-3 pb-3">
            <h3 class="mb-1">답변 보존 캠페인 재배정</h3>
            <p class="text-muted mb-0">
                업체의 캠페인을 바꾸되, 새 캠페인에도 있는 문항의 답변은 삭제하지 않고 이어붙입니다.
                표준 재배정(평가데이터 전체 삭제 후 재작성)과 달리 응답자가 다시 입력할 필요가 없습니다.
            </p>
        </div>

        <b-tabs v-model="tabIndex" content-class="mt-3" lazy>
            <b-tab title="재배정 실행">
                <remap-execute-tab @go-history="goHistory"/>
            </b-tab>
            <b-tab title="실행 이력 / 백업">
                <remap-history-tab :auto-open-log-id="pendingLogId" @auto-opened="pendingLogId = null"/>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
/**
 * 답변 보존 캠페인 재배정 관리 화면 (셸).
 *
 * 담당자가 수동 SQL 로 처리하던 작업을 관리자 화면으로 옮긴 것. 파괴적 작업이라
 * 실행은 미리보기 → 확인 → 실행 2단계이며, 삭제된 원본은 이력 탭에서 회수한다.
 */
import RemapExecuteTab from './RemapExecuteTab.vue';
import RemapHistoryTab from './RemapHistoryTab.vue';

export default {
    name: 'CampaignRemap',
    components: {RemapExecuteTab, RemapHistoryTab},
    data() {
        return {
            tabIndex: 0,
            pendingLogId: null,
        };
    },
    methods: {
        /** 실행 직후 "백업 확인" 을 누르면 이력 탭으로 넘어가 그 건을 바로 연다.
         *
         * ⛔ $refs 로 자식 메서드를 부르지 않는다 — lazy 탭은 활성화될 때 마운트되므로
         *    ref 가 언제 잡히는지 보장되지 않는다. prop 으로 넘겨 자식이 자기 마운트
         *    시점에 처리하게 한다.
         */
        goHistory(logId) {
            this.pendingLogId = logId;
            this.tabIndex = 1;
        },
    },
};
</script>
